import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import { useEffect, useState } from "react";
import axios from "axios";

const styles = {
  button: { padding: "5px 30px", fontWeight: "bold" },
  cell: {
    padding: "10px",
    paddingLeft: "30px",
    textAlign: "left",
    textTransform: "uppercase",
    fontWeight: "600",
    fontSize: "16px",
    verticalAlign: "top"
  }
};

function RadnoMestoPrikaz({ close, id, handleOpenEdit }) {
  const [data, setData] = useState(null);
  const { dictionary, baseUrl } = useGlobalContext();

  useEffect(() => {
    if (!id) return;
    const fetchOne = async () => {
      try {
        const { data: res } = await axios.post(
          `${baseUrl}/workplaces/read_one.php`,
          {
            workplace_id: id
          }
        );
        if (res.status === 200) setData(res.data);
      } catch (e) {
        console.error("Greška:", e);
      }
    };
    fetchOne();
  }, [id]);

  if (!data) return null;

  const posebniSvi = [
    ...(data.posebni_uslovi || []).map((x) => x.naziv),
    ...(data.strani_jezici || []).map((x) => x.naziv),
    ...(data.vozacke_dozvole || []).map((x) => x.naziv),
    ...(data.it_vestine || []).map((x) => x.naziv),
    ...(data.dodatni_uslovi || []).map((x) => x.naziv)
  ];

  return (
    <div
      style={{
        padding: "5px",
        backgroundColor: "#ccc",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div
        style={{
          overflowY: "auto",
          flex: 1,
          backgroundColor: "#f9f9f9",
          padding: "20px"
        }}
      >
        <table style={{ width: "100%" }}>
          <tr>
            <td style={{ ...styles.cell, width: "30%" }}>
              {data.workplace_id}.
            </td>
            <td style={{ ...styles.cell, width: "70%" }}>
              {data.workplace_name}
            </td>
          </tr>
          <tr>
            <td style={styles.cell}>{dictionary["rizik"]}</td>
            <td style={styles.cell}>{data.stepen_rizika || "-"}</td>
          </tr>
          <tr>
            <td style={styles.cell}>{dictionary["strucnaSprema"]}</td>
            <td style={styles.cell}>
              {(data.spreme || []).length > 0
                ? data.spreme.map((s) => s.naziv).join(", ")
                : "-"}
            </td>
          </tr>
          <tr>
            <td style={styles.cell}>{dictionary["radnoIskustvo"]}</td>
            <td style={styles.cell}>{data.iskustvo || "-"}</td>
          </tr>
          <tr>
            <td style={styles.cell}>{dictionary["opisPoslova"]}</td>
            <td style={{ ...styles.cell, whiteSpace: "pre-line" }}>
              {data.opis_poslova || "-"}
            </td>
          </tr>
          <tr>
            <td style={styles.cell}>{dictionary["posebniUslovi"]}</td>
            <td style={{ ...styles.cell, whiteSpace: "pre-line" }}>
              {posebniSvi.length > 0 ? posebniSvi.join("\n") : "-"}
            </td>
          </tr>
          <tr>
            <td style={styles.cell}>{dictionary["zaposleni"]}</td>
            <td style={{ ...styles.cell, whiteSpace: "pre-line" }}>
              {(data.imena || []).length > 0 ? data.imena.join("\n") : "-"}
            </td>
          </tr>
          <tr>
            <td
              colSpan={2}
              style={{
                padding: "10px 30px",
                fontSize: "18px",
                whiteSpace: "pre-line",
                fontWeight: "500"
              }}
            >
              {data.opis_poslova || ""}
            </td>
          </tr>
        </table>
      </div>

      <div style={{ display: "flex", gap: "20px", marginTop: "15px" }}>
        <div style={{ fontWeight: "bold", fontSize: "30px", width: "25%" }}>
          {data.workplace_id}.
        </div>
        <div style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["stampaj"]}
          </Button>
        </div>
        <div style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["posalji"]}
          </Button>
        </div>
        <div onClick={close} style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["nazad"]}
          </Button>
        </div>
        <div onClick={handleOpenEdit} style={{ width: "25%" }}>
          <Button activation={true} style={styles.button}>
            {dictionary["izmeni"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default RadnoMestoPrikaz;
